var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.047 3.41c.041-.058.087-.128.146-.223l.123-.202.049-.08c.483-.792.835-1.155 1.468-1.155H8.75v1.167H5.833c-.05 0-.21.164-.473.596l-.042.07a48.35 48.35 0 0 1-.133.217 4.886 4.886 0 0 1-.191.291c-.262.364-.523.576-.91.576h-1.75a.583.583 0 0 0-.584.583v5.25c0 .322.261.584.583.584h9.334a.583.583 0 0 0 .583-.584V7h1.167v3.5a1.75 1.75 0 0 1-1.75 1.75H2.333a1.75 1.75 0 0 1-1.75-1.75V5.25c0-.966.784-1.75 1.75-1.75h1.643c.02-.022.043-.052.07-.09zm5.87 1.257V3.5h1.167V2.333h1.166V3.5h1.167v1.167H12.25v1.166h-1.166V4.667H9.917zM7 10.5a2.917 2.917 0 1 1 0-5.833A2.917 2.917 0 0 1 7 10.5zm0-1.167a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.083b3b30999d3a5a8119008e2e3a97a5.svg";
export { ForwardRef as ReactComponent };